import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FullTable } from 'components';
import { useModal, usePrimaryModal} from 'utils';
import { CUSTOMER_PMT_LOADS, pmtLoadBody, pmtLoadHead } from './constants';
import { CustomDeleteModal } from '../../modals';
import { customerPaymentActions } from 'store';
import { EditLoadDesc } from './editLoadDesc';
import { LoadDetailSwitcher } from '../../../pages';

const VOID_ACTION = 'VOID_CUSTOMER_PAYMENT_LOAD'
export const PmtLoads = ({  }) => {
  const { customerPaymentLoad, customerPaymentById } = useSelector((state) => ({
    customerPaymentLoad: state.customerPayments.customerPaymentLoad,
    customerPaymentById: state.customerPayments.customerPaymentById,
  }));
  const { open, close } = useModal();
  const { openPrimary } = usePrimaryModal();
  const dispatch = useDispatch();
  const handleSuccess = () => {
    close()
    dispatch(customerPaymentActions.getCustomerPaymentById(customerPaymentById?.id, 'noLoad'));
    dispatch(customerPaymentActions.getCustomerPaymentLoad(customerPaymentById?.id));
  }

  const pushPageDetails = (item, name) => {
    if(name === 'edit') {
      open(<EditLoadDesc info={item}/>)
    }
    if (name === 'void'){
      open(
        <CustomDeleteModal
          afterSuccess={handleSuccess}
          actionType={VOID_ACTION}
          type={'void'}
          text={'Void Load?'}
          modalText={'Are you sure? You wont Void this load ?'}
          handleDel={() => dispatch(customerPaymentActions.voidCustomerPaymentLoad(customerPaymentById?.id, item?.id))}
        />,
      );
    }
  }

  const handleShowLoadDetails = (item) => {
    openPrimary(<LoadDetailSwitcher loadId={item?.load} />);
  }

  return(
    <div>
      <FullTable
        head={pmtLoadHead}
        body={pmtLoadBody}
        loadingType={CUSTOMER_PMT_LOADS}
        list={customerPaymentLoad}
        handleClickButton={pushPageDetails}
        handleClick={handleShowLoadDetails}
        clickType={'item'}
        noText={'Orders'}
        height={'small'}
      />
    </div>
  )
}